// API
import { login } from "../../../../../shared/api/auth/index";
// Types
import { ILoginResponse } from "../../../../../shared/api/auth/login";
// Types
export type ILoginRequest = {
	email: string;
	password: string;
};
// Функция отправки запроса на логинизацию
export const loginRequest = async ({
	email,
	password,
}: ILoginRequest): Promise<ILoginResponse> => {
	const body = { email, password };
	const response = await login(body);
	return response;
};
